module.exports = __webpack_public_path__ + "media/configurations/SV_P-X-X-P-2aff86fb.png";